import React from "react";
import { List } from "semantic-ui-react";
import { formatCurrency } from "shared/services/PriceService";
import { connect } from 'react-redux';
import { getSelectedCalculations } from "shared/selectors/cartSelectors";
import config from "shared/config/config";
import { withStyles } from "@material-ui/core";
import messages, { FormattedMessage, withValues } from 'shared/messages/messages';

const styles = theme => ({
  priceGuideHeader: {
    margin: '20px',
    fontWeight: 'bold',
    color: config.pwa_default_font_color + ' !important'
  },
  priceGuideDetails: {
    color: config.pwa_default_font_color + ' !important',
  }
})

class PriceGuide extends React.Component {
  render() {
    const { calculations, currency, pricingModel, classes, locale } = this.props;

    let discounts;
    if (this.props.discounts) {
      discounts = this.props.discounts.map(({ message: { id, values } }) => {
        return (<List.Item>
          <List.Content>
            <span className={classes.priceGuideDetails}>
              <FormattedMessage {...withValues(messages[id], Object.assign(values, {show_change: true}))} />
            </span>
          </List.Content>
        </List.Item>);
      });
    }

    let instr = null;
    if (pricingModel !== 3 && discounts) {
      instr = <p style={{ marginBottom: '1.5rem' }}>
        <FormattedMessage {...messages.cart_discount_label} />
      </p>;
    }

    let priceFormatted = formatCurrency(calculations?.price_per_unit, currency, true);

    let boughtAll = calculations?.buy_all_applied;

    let standardPrice;
    if (boughtAll) {
      standardPrice = <List.Item>
        <span className={classes.priceGuideDetails}>
          <FormattedMessage {...messages.cart_add_image_no_cost} />
        </span>
      </List.Item>;
    } else {
      standardPrice = <List.Item>
        <span className={classes.priceGuideDetails}>
          <FormattedMessage {...withValues(messages.cart_standard_price, { amount: priceFormatted })} />
        </span>
      </List.Item>;
    }
    return (
      <List>
        <List.Item>
          <List.Content>
            <List.Header>
              <span className={classes.priceGuideHeader}>
                <FormattedMessage {...messages.cart_price_guide} />
              </span>
            </List.Header>
          </List.Content>
        </List.Item>
        {
          instr &&
          <List.Item>
            <span className={classes.priceGuideDetails}>
              {instr}
            </span>
          </List.Item>
        }
        {standardPrice}
        {discounts}
      </List>
    )
  }
}

const mapStateToProps = state => ({
  currency: state.cartReducer.calculations.currency,
  calculations: getSelectedCalculations(state),
  pricingModel: state.cartReducer.calculations.pricing_model,
  discounts: state.cartReducer.calculations.discounts,
  user: state.userReducer.user,
  locale: state.messagesReducer.locale
});
export default connect(mapStateToProps, {})(withStyles(styles, { withTheme: true })(PriceGuide));
